import axios from 'axios';

const DEFAULT_API_BASE_URLS = [
  process.env.REACT_APP_API_URL,
  // 'http://localhost:5000',
  // 'http://localhost:400',
  // "https://sf5zj63q-4000.inc1.devtunnels.ms",
  // 'http://localhost:4000',
  // 'http://localhost:600',
  // 'http://localhost:4000',
  // "https://tavlapro-testing.onrender.com", //  demo.tavlapro.com
 'https://backgammon-backend-uose.onrender.com',  
  // 'https://backgammon-backend-jb26.onrender.com',  testing
  //'https://sonu-backgammon-backend.onrender.com'  //sonu
  
];

export const API_BASE_URL = DEFAULT_API_BASE_URLS.find((url) => typeof url === 'string' && url.trim())?.trim() || '';

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
}

export default api;
